export const getRiskSlice = (state) => state.risks;
export const getEstimatesFromRiskSlice = (state) => state.risks?.estimates;

export const getRisksPagingOptions = (state) => {
	let pagingOptions = {
		page: getRiskSlice(state)?.page,
		pages: getRiskSlice(state)?.pages
	};
	return pagingOptions;
};
export const getEstimatesPagingOptions = (state) => {
	let pagingOptions = {
		page: getEstimatesFromRiskSlice(state)?.page,
		pages: getEstimatesFromRiskSlice(state)?.pages
	};
	return pagingOptions;
};
